// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"3d1117c2","455":"be4b13f8","977":"e55f2161"}[chunkId] + ".chunk.js";
};